import { api } from "../api"

export default async function find(term: string) {
    try {
        const textToSearch = term.replace('/', '');
        const { data } = await api.get(`/search-assets/${textToSearch}`);

        return data;
    } catch (err) {
        console.log(err)
    }
}